




import Vue from 'vue';
import Component from 'vue-class-component';
import CreateContactForm from '@/modules/contacts/management/components/CreateContactForm.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
@Component({
    components: { CreateContactForm },
})
export default class CreateContactView extends Vue {
    mounted() {
        this.CHANGE_TITLE({ route: ['CONTACTOS'], title: 'CREAR CONTACTO' });
    }

    @layout.Mutation('changeTitle') CHANGE_TITLE!: (title: {
        route: string[];
        title: string;
    }) => void;
}
